module.exports = __webpack_public_path__ + "static/media/2.cc8344f8.png";